module.exports = __webpack_public_path__ + "static/media/vivian_nguyen.17423662.png";